<template>
  <b-modal
    :id="idModalQuestionSample"
    hide-footer
    hide-header
    class="modal-info modal-prepare__detail question-available"
    size="xl"
    scrollable
    centered
    no-close-on-esc
    no-close-on-backdrop
    @show="getDatas"
    @hidden="handleCloseModal"
  >
    <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light display-flex full-box">
      <div class="modal-question__left">
        <h2 class="primary-color-txt font-size-20 font-sanpro-semibold">Câu hỏi có sẵn</h2>
        <div class="modal-question__classes">
          <SidebarCatsOfBook v-if="bookIdQuestions && bookIdQuestions > 0" :keyword="keyword" />
          <SidebarCatsOfAutoTest v-else-if="paramFilterQuestionsByChapter.chapterId > 0 " :keyword="keyword" />
          <SidebarCatsOfExam v-else-if="paramFilterQuestionsByChapter.examId > 0 " :keyword="keyword" />
          <SidebarClassesModal v-else />
        </div>
      </div>
      <div class="modal-question__right position-rel">
        <div
          v-if="(bookIdQuestions && bookIdQuestions > 0) || paramFilterQuestionsByChapter.chapterId > 0"
          class="modal-question__right__head display-flex-center justify-content-between"
        >
          <span class="font-size-18 font-sanpro-semibold primary-color-txt">Đã chọn {{ questionsChoose.length }} câu</span>
          <div class="item item__key input-custom-icon">
            <input 
              v-model.lazy="keyword"
              v-debounce="300"
              type="text"
              placeholder="Tìm kiếm"
              class="primary-color-txt color_bg_gray_light border-rd-20 font-size-16 form-h30 border-0 full-width input-search"
            >
            <i class="icon-search font-size-16 primary-color"></i>
          </div>
        </div>
        <div class="modal-question__right__body">
          <ModalQuestionSampleList v-if="(bookIdQuestions && bookIdQuestions > 0) || paramFilterQuestionsByChapter.chapterId > 0 || paramFilterQuestionsByChapter.examId >0" />
          <div v-else class="modal-question__right__body__sub">
            <ModalQuestionsInBook :dataSource="listPracticeBook" />
            <ModalQuestionsAutoTest :dataSource="listPracticeTKTDG" />
            <ModalThematic v-if="listPracticeThematic && listPracticeThematic.length >0" :dataSource="listPracticeThematic" />
            <ModalExam v-if="listPracticeExam && listPracticeExam.length >0" :dataSource="listPracticeExam" />
          </div>
        </div>
        <div class="modal-question__right__bottom display-flex-center justify-content-end">
          <a href="javascript:;" class="primary-color font-size-16 font-sanpro-semibold btn-close" @click="$bvModal.hide(idModalQuestionSample)">
            Hủy
          </a>
          <a
            href="javascript:;"
            class="btn btn-main font-size-16 font-sanpro-semibold display-flex-center justify-content-center border-rd-20"
            @click="doneSetQuestionSample"
          >
            Hoàn thành
          </a>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
// import { getCatOfExerciseOtherOrThematic } from '@/modules/exercises/_api'
import { apiGetListChooseQuestion, apiCreateQuestion } from './../../_api/exam'
import SidebarClassesModal from './SidebarClassesModal.vue'
import ModalQuestionsInBook from './ModalQuestionsInBook.vue'
import ModalThematic from './ModalThematic'
import ModalExam from './ModalExam'
import ModalQuestionsAutoTest from './ModalQuestionsAutoTest.vue'
import SidebarCatsOfBook from './SidebarCatsOfBook.vue'
import SidebarCatsOfExam from './SidebarCatsOfExam.vue'
import ModalQuestionSampleList from './ModalQuestionSampleList.vue'
import SidebarCatsOfAutoTest from './SidebarCatsOfAutoTest.vue'
import debounce from "@/directives/debounce"

export default {
  name: 'ModalQuestionSample',
  directives: { debounce },
  components: {
    SidebarClassesModal,
    ModalQuestionsAutoTest,
    ModalQuestionsInBook,
    SidebarCatsOfBook,
    ModalQuestionSampleList,
    SidebarCatsOfAutoTest,
    ModalExam,
    ModalThematic,
    SidebarCatsOfExam
  },
  data () {
    return {
      listPracticeBook: [],
      listPracticeTKTDG: [],
      listPracticeThematic: [],
      listPracticeExam: [],
      keyword: ''
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['questionList', 'idModalQuestionSample', 'paramsGetQuestionsSample', 'bookIdQuestions', 'questionsChoose', 'chapterIdQuestion', 'paramFilterQuestionsByChapter','paramFilterQuestionsByExam'])
  },
  watch: {
    'paramsGetQuestionsSample': 'getDatas'
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetListQuestions', 'acSetParamsGetQuestionsData', 'acSetBookIdFilterQuestions', 'acSetBookIndexIdFilterQuestions', 'acSetQuestionSample', 'acSetQuestionsChoosed', 'acSetQuestionsIdChoosed']),

    handleCloseModal () {
      this.acSetBookIdFilterQuestions(0)
      this.acSetBookIndexIdFilterQuestions(0)
      this.acSetQuestionSample([])
      this.acSetQuestionsChoosed([])
      this.acSetQuestionsIdChoosed([])
    },

    getDatas () {
      let self = this
      // self.setLoading(true)
      apiGetListChooseQuestion(self.paramsGetQuestionsSample).then(res =>{
        if (res) {
          self.listPracticeBook = res.listPracticeBook
          self.listPracticeTKTDG = res.listPracticeTKTDG
          self.listPracticeThematic = res.listPracticeChuyende
          self.listPracticeExam = res.listPracticeExam
        }
      }).finally(() => self.setLoading(false))
    },

    async doneSetQuestionSample () {
      let self = this
      // console.log('Question choosed: ', this.questionsChoose)
      if (self.questionsChoose && self.questionsChoose.length > 0) {
        self.setLoading(true)
        const requestAddQuestion = await self.questionsChoose.map(item => {
          item.questionId = 0
          item['isSample'] = true
          delete item.createBy
          delete item.updateBy
          item.answers && item.answers.map(ans => {
            ans.answerId = 0
            ans.questionId = 0
          })
          return apiCreateQuestion(item)
        });

        Promise.all(requestAddQuestion).then(res => {
          self.acSetListQuestions([...self.questionList, ...res])
        }).finally(() => {
          self.$bvModal.hide(self.idModalQuestionSample)
          self.setLoading(false)
        })
      }
    },
  }
}
</script>

<style lang="scss">
.modal-dialog-scrollable .modal-body {
  overflow: hidden!important;
      min-height: calc(100vh - 3.5rem);
}
.btn-close{
  margin-right: 25px;
}
.modal-info__body{
  padding: 0 !important;
}

.modal-question__left{
    background: #f3f6fb;
    padding: 15px;
    width: 25%;
}
.modal-question__right{
  width: 75%;
  padding: 15px;
  // follow with modal content
  max-height: calc(100vh - 3.5rem);

  &__bottom{
    position: absolute;
    bottom: 0;
    right: 0;
    @extend .full-width;
    @extend .bg-color-light;
    padding: 15px;
  }

  &__body {
    height: calc(100% - 80px);
    overflow: auto;

    &__sub {
      padding: 15px 0;
    }
  }
}
.input-search {
  min-width: 250px;

  ~ i {
    font-size: 18px!important;
  }
}
</style>